import Vue from 'vue';
import Vuex from 'vuex';
import Platforms from './modules/platforms';
import TargetBuilds from './modules/targetBuilds';
import TestRuns from './modules/testRuns';
import TestSuites from './modules/testSuites';
import TestCases from './modules/testCases';
import TestResults from './modules/testResults';
import UploadRequests from "./modules/uploadRequests";
import Logs from './modules/logs';
import Auth from './modules/auth';

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    Platforms,
    TargetBuilds,
    TestRuns,
    TestSuites,
    TestCases,
    TestResults,
    UploadRequests,
    Logs,
    Auth,
  },
  strict: debug,
})
